import { getCLS, getFID, getLCP } from 'web-vitals';

function writeToDataLayer({ name, delta, id }) {
    if (typeof dataLayer === 'object' && Array.isArray(dataLayer)) {
        dataLayer.push({
            eventCategory: 'Web Vitals',
            eventAction: name,
            eventLabel: id,
            eventValue: Math.round(name === 'CLS' ? delta * 1000 : delta),
        });
    }
}

getCLS(writeToDataLayer);
getFID(writeToDataLayer);
getLCP(writeToDataLayer);
